import React, { createContext, useContext, useState, useEffect } from 'react';

const AccountContext = createContext();

export const useAccount = () => {
  const context = useContext(AccountContext);
  if (!context) throw new Error('useAccount must be used within AccountProvider');
  return context;
};

export const AccountProvider = ({ children }) => {
  const [account, setAccount] = useState(() => {
    try {
      const saved = localStorage.getItem('uas_admin_account');
      return saved ? JSON.parse(saved) : undefined;
    } catch {
      return undefined;
    }
  });

  useEffect(() => {
    if (account) {
      localStorage.setItem('uas_admin_account', JSON.stringify(account));
    } else {
      localStorage.removeItem('uas_admin_account');
    }
  }, [account]);

  const updateAccount = (data) => setAccount(prev => ({ ...prev, ...data }));
  const clearAccount = () => {
    setAccount(null);
    localStorage.removeItem('uas_admin_account');
  };

  return (
    <AccountContext.Provider value={{ account, updateAccount, clearAccount }}>
      {children}
    </AccountContext.Provider>
  );
};
